export default {"src":"/_next/static/media/mt5-android.690a5639.svg","height":394,"width":555,"blurWidth":0,"blurHeight":0};